<script>
export default {
    data() {
        return {
            left: 0,
            menus: []
        }
    },
    created() {
        this.$store.dispatch('getMenus').then(res => {
            this.menus = res
        })
    },
    mounted() {

    },
    methods: {
        handleClick(item) {
            if (!item.path) return this.$message.error('菜单管理 `前端路由` 权限无配置')
            this.$router.push({ name: item.path })
        },
        handleSiderLeft(arrow) {
            this.left = arrow == 'r' ? 0 : '-400px'
        },
        // 将后端返回的菜单图标 URL 统一映射到本地 public/images 目录，
        // 避免本地开发时访问不到远端静态资源（如 114.117.233.19:8089）
        resolveIcon(url) {
            if (!url) return ''
            try {
                // 取 URL 末尾的文件名（兼容绝对/相对路径、带 query 的情况）
                const clean = String(url).split('?')[0].split('#')[0]
                const filename = clean.substring(clean.lastIndexOf('/') + 1)
                if (filename) return '/images/' + filename
            } catch (e) {
                // ignore
            }
            return url
        }
    }
}
</script>

<template>
    <div class="menu-wrapper" :style="{ left: left }">
        <!-- 菜单容器，层级较高且可滚动 -->
        <div class="menu-container">
            <el-menu :default-active="$route.meta.title" class="el-menu-vertical-demo" text-color="#ffffff"
                active-text-color="#ffffff" style="width:100%;">
                <el-menu-item :index="$win.mconfig.welcome">
                    <img :src="resolveIcon('menu_hello.png')" alt="图标" style="width:18px; height:18px; margin-right:10px;" />
                    <span slot="title">欢迎页</span>
                </el-menu-item>
                <div v-for="item, index in menus" :key="index * 10 + 10">
                    <el-menu-item :index="item.title" v-if="!item.children && item.isShow" @click="handleClick(item)">
                        <img v-if="item.iconUrl" :src="resolveIcon(item.iconUrl)" alt="图标" style="width:18px; height:18px; margin-right:10px;" />
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                    <el-submenu :index="item.title" v-else-if="item.children && item.isShow">
                        <template slot="title">
                            <img v-if="item.iconUrl" :src="resolveIcon(item.iconUrl)" alt="图标" style="width:18px; height:18px; margin-right:10px;" />
                            <span>{{ item.title }}</span>
                        </template>
                        <div v-for="itx, inx in item.children" :key="inx * 100 + 100">
                            <el-menu-item v-if="itx.type == 2 && itx.isShow" :index="itx.title"
                                @click="handleClick(itx)">
                                <img v-if="itx.iconUrl" :src="resolveIcon(itx.iconUrl)" alt="图标" style="width:18px; height:18px; margin-right:10px;" />
                                <span slot="title">{{ itx.title }}</span>
                            </el-menu-item>
                        </div>
                    </el-submenu>
                </div>
            </el-menu>
            <!-- 底部固定logo -->
            <div class="sider-bottom-logo">
                <img src="../assets/home/sider_logo.svg" alt="Logo" />
            </div>
        </div>

        <!-- 侧边栏收缩按钮 -->
        <div class="sider-toggle">
            <svg v-if="left == 0" @click="handleSiderLeft('l')" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" width="36" height="36">
                <path
                    d="M388.266667 512l149.333333 149.333333 59.733333-59.733333-89.6-89.6L597.333333 422.4l-59.733333-59.733333L388.266667 512zM853.333333 512c0-187.733333-153.6-341.333333-341.333333-341.333333s-341.333333 153.6-341.333333 341.333333 153.6 341.333333 341.333333 341.333333 341.333333-153.6 341.333333-341.333333z m-85.333333 0c0 140.8-115.2 256-256 256s-256-115.2-256-256 115.2-256 256-256 256 115.2 256 256z"
                    fill="#444444"></path>
            </svg>
            <svg v-else @click="handleSiderLeft('r')" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" width="36" height="36">
                <path
                    d="M635.733333 512l-149.333333-149.333333L426.666667 422.4l89.6 89.6-89.6 89.6 59.733333 59.733333 149.333333-149.333333zM170.666667 512c0 187.733333 153.6 341.333333 341.333333 341.333333s341.333333-153.6 341.333333-341.333333-153.6-341.333333-341.333333-341.333333-341.333333 153.6-341.333333 341.333333z m85.333333 0c0-140.8 115.2-256 256-256s256 115.2 256 256-115.2 256-256 256-256-115.2-256-256z"
                    fill="#444444"></path>
            </svg>
        </div>
    </div>
</template>

<style scoped lang="less">
.menu-wrapper {
    width: calc(100% - 30px);
    height: calc(100% - 56px);
    margin-left: 30px;
    margin-top: 10px;
    margin-bottom: 46px;
    background: url('../assets/home/sider_bg.png') no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    z-index: 1;
    padding: 60px 20px 0 20px;
    overflow: hidden;
    /* 确保整个Menu不滚动 */
    box-sizing: border-box;

    a {
        color: inherit;
    }
}

/* 菜单容器，层级较高且可滚动 */
.menu-container {
    position: relative;
    z-index: 10;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    /* 隐藏滚动条但保持滚动功能 */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 和 Edge */
}

/* Chrome, Safari 和 Opera */
.menu-container::-webkit-scrollbar {
    display: none;
}

/* 侧边栏收缩按钮 */
.sider-toggle {
    position: absolute;
    left: 100%;
    bottom: 40px;
    width: 30px;
    height: 40px;
    display: none;
    background: transparent !important;
}

@media (max-width:990px) {
    .sider-toggle {
        display: block;
    }
}

@media (min-width:990px) {
    .menu-wrapper {
        left: 0 !important;
    }
}

/* 底部居中图片样式 - 固定定位且层级较低 */
.sider-bottom-logo {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 248px;
        height: auto;
    }
}

/* 主菜单容器样式 */
.el-menu,
.el-menu-vertical-demo {
    width: 100%;
    background: transparent !important;
}

/* 基础菜单容器样式 - 保持透明 */
/deep/ .el-menu,
/deep/ .el-menu--vertical {
    background: transparent !important;
    border: none !important;
}

/* 为el-submenu添加渐变背景和间距 */
/deep/ .el-submenu {
    margin-bottom: 10px;
    /* submenu之间的间距 */
    // background: linear-gradient(135deg, rgba(0, 110, 255, 0.3) 0%, rgba(0, 59, 137, 0.3) 100%) !important;
    // border-radius: 6px;
    overflow: hidden;
    background: linear-gradient(180deg, rgba(0, 110, 255, 0.3) 0%, rgba(0, 59, 137, 0.3) 100%);
    border-radius: 2px;
    // opacity: 0.5;
    border: 1px solid;
    border-image: linear-gradient(270deg, rgba(56.000000461936, 142.00000673532486, 255, 0.6000000238418579), rgba(56.000000461936, 142.00000673532486, 255, 0.240000013113022), rgba(56.000000461936, 142.00000673532486, 255, 0.240000013113022), rgba(56.000000461936, 142.00000673532486, 255, 0.6000000238418579)) 1 1;
}

/* 设置展开的子菜单样式，使其与父菜单背景形成整体 */
/deep/ .el-submenu .el-menu {
    // background: linear-gradient(135deg, rgba(0, 110, 255, 0.3) 0%, rgba(0, 59, 137, 0.3) 100%) !important;
    border: none !important;
    padding: 0 !important;
    background: linear-gradient(180deg, rgba(0, 110, 255, 0.3) 0%, rgba(0, 59, 137, 0.3) 100%);
    border-radius: 2px;
    border: 1px solid;
    // opacity: 0.5;
    border-image: linear-gradient(270deg, rgba(56.000000461936, 142.00000673532486, 255, 0.6000000238418579), rgba(56.000000461936, 142.00000673532486, 255, 0.240000013113022), rgba(56.000000461936, 142.00000673532486, 255, 0.240000013113022), rgba(56.000000461936, 142.00000673532486, 255, 0.6000000238418579)) 1 1;
}

/* 设置submenu标题高度为54px */
/deep/ .el-submenu>.el-submenu__title {
    height: 54px !important;
    line-height: 54px !important;
    background: transparent !important;
    /* 继承父级渐变背景 */
    margin: 0 !important;
}


/* 子菜单项样式 */
/deep/ .el-submenu .el-menu-item {
    height: 54px !important;
    line-height: 54px !important;
    background: transparent !important;
    margin-bottom: 0 !important;
    padding-left: 45px !important;
}

/* 无子菜单的菜单项 */
/deep/ .el-menu-item:not(.el-submenu .el-menu-item) {
    height: 54px !important;
    line-height: 54px !important;
    // background: linear-gradient(135deg, rgba(0, 110, 255, 0.3) 0%, rgba(0, 59, 137, 0.3) 100%) !important;
    margin-bottom: 10px;

    background: linear-gradient(180deg, rgba(0, 110, 255, 0.3) 0%, rgba(0, 59, 137, 0.3) 100%);
    border-radius: 2px;
    // opacity: 0.5;
}

/* 图标样式 */
/deep/ .el-menu-item img,
/deep/ .el-submenu__title img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    vertical-align: middle;
}

/* 活动状态样式 */
/deep/ .el-menu-item.is-active {
    //   background: rgba(45, 140, 240, 0.7) !important;
    // background: linear-gradient(135deg, rgba(0, 110, 255, 0.3) 0%, rgba(0, 59, 137, 0.3) 100%) !important;
    background: linear-gradient(90deg, rgba(21, 113, 231, 0.89) 0%, rgba(21, 113, 231, 0) 100%) !important;
    color: #ffffff !important;
}

/* 确保展开状态的submenu标题也保持渐变背景 */
/deep/ .el-submenu.is-opened>.el-submenu__title {
    background: transparent !important;
}
</style>